"use client";

import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { useMemo } from "react";
import { NacoHandler } from "../types";
import { nacoHandler } from "./naco-handler";

export function useNaco(): NacoHandler {
  const config = useClientConfig();

  return useMemo(() => {
    return nacoHandler(config?.accessToken, () => window.location.reload());
  }, [config?.accessToken]);
}